module.exports = __webpack_public_path__ + "static/media/Bedroom5-1.e03c7e69.jpg";